import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVesselStateIcon implements BaseEnumType {
  private static allValues: EnumVesselStateIcon[] = []; // make sure this is top-most
  
  public static none = new EnumVesselStateIcon(0, "None", "enum_vessel_state_icon_none");
  public static tick = new EnumVesselStateIcon(1, "Tick", "enum_vessel_state_icon_tick");
  public static bubbles = new EnumVesselStateIcon(2, "Bubbles", "enum_vessel_state_icon_bubbles");
  public static snowflake = new EnumVesselStateIcon(3, "Snowflake", "enum_vessel_state_icon_snowflake");
  public static hops = new EnumVesselStateIcon(4, "Hops", "enum_vessel_state_icon_hops");
  public static fire = new EnumVesselStateIcon(5, "Fire", "enum_vessel_state_icon_fire");
  public static grainEar = new EnumVesselStateIcon(6, "GrainEar", "enum_vessel_state_icon_grain_ear");
  public static liquid = new EnumVesselStateIcon(7, "Liquid", "enum_vessel_state_icon_liquid");
  public static funnel = new EnumVesselStateIcon(8, "Funnel", "enum_vessel_state_icon_funnel");
  public static grain = new EnumVesselStateIcon(9, "Grain", "enum_vessel_state_icon_grain");
  public static yeast = new EnumVesselStateIcon(10, "Yeast", "enum_vessel_state_icon_yeast");
  public static apple = new EnumVesselStateIcon(11, "Apple", "enum_vessel_state_icon_apple");
  public static mop = new EnumVesselStateIcon(12, "Mop", "enum_vessel_state_icon_mop");
  public static stop = new EnumVesselStateIcon(13, "Stop", "enum_vessel_state_icon_stop");
  public static spanner = new EnumVesselStateIcon(14, "Spanner", "enum_vessel_state_icon_spanner");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselStateIcon.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumVesselStateIcon.none; }
  public isTick() { return this === EnumVesselStateIcon.tick; }
  public isBubbles() { return this === EnumVesselStateIcon.bubbles; }
  public isSnowflake() { return this === EnumVesselStateIcon.snowflake; }
  public isHops() { return this === EnumVesselStateIcon.hops; }
  public isFire() { return this === EnumVesselStateIcon.fire; }
  public isGrainEar() { return this === EnumVesselStateIcon.grainEar; }
  public isLiquid() { return this === EnumVesselStateIcon.liquid; }
  public isFunnel() { return this === EnumVesselStateIcon.funnel; }
  public isGrain() { return this === EnumVesselStateIcon.grain; }
  public isYeast() { return this === EnumVesselStateIcon.yeast; }
  public isApple() { return this === EnumVesselStateIcon.apple; }
  public isMop() { return this === EnumVesselStateIcon.mop; }
  public isStop() { return this === EnumVesselStateIcon.stop; }
  public isSpanner() { return this === EnumVesselStateIcon.spanner; }

  public static getValues(): readonly EnumVesselStateIcon[] {
    return EnumVesselStateIcon.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselStateIcon[] {
    return EnumVesselStateIcon.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselStateIcon {
    const found = EnumVesselStateIcon.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselStateIcon - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselStateIcon): EnumVesselStateIcon {
    const found = name ? EnumVesselStateIcon.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselStateIcon - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVesselStateIcon>): boolean {
    return this.key === other?.key;
  }
}